<template>
  <div class="top-div" style="background-color: #F3F5F8;">
    <div class="uploader-header">
      <div class="d-flex justify-content-between">
        <div class="p-3" @click="clearResults" style="cursor: pointer"><i class="far fa-times"></i></div>
        <div class="p-3"><i class="fas fa-ellipsis"></i></div>
      </div>
    </div>
    <div class="main-div">
      <div :style="`min-height:`+height+`px;`"
           class="drag-drop-upload" @dragover="handleDragOver" @dragleave="handleDragOver" @drop="handleFileSelect"
           @click="clickInput" :class="{'dragging' : dragging}">

        <label :for="fileId" class="file-input">
          <slot name="upload-container" v-if="!dragging">
            {{ title }}
          </slot>
          <span class="d-block drag-title" v-if="!dragging">
            فایل را برای آپلود به اینجا بکشید یا کلیک کنید
          </span>
          <slot name="dragging-container" v-if="dragging">
            برای آپلود فایل را اینجا رها کنید
          </slot>
          <input multiple  :id="fileId" type="file" :accept="supportedFile" @change="handleFileInput"
                 ref="fileInput">
        </label>

      </div>
    </div>
    <div v-if="results && results.length">
      <swiper class="img-results"
          :slides-per-view="'auto'"
              :rtl="true"
          :space-between="10">
        <swiper-slide v-for="(result,index) in results" :key="result" class="img-div">
          <i @click="deletePic(index)" class="fas fa-times remove-btn"></i>
          <img :src="result.filePreview" alt="pic">
          <input type="file" :name="name" :id="result.file_id">
        </swiper-slide>
      </swiper>
    </div>
  </div>

</template>

<script>

import imageCompression from "browser-image-compression";
import {makeCode} from "@/shared/helper";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
export default {
  name: "DragDropMultiFileUpload",
  components : {Swiper,SwiperSlide },
  props: {
    old_files : {type : Array,default : undefined},
    title: {type: String},
    optional: {type: Boolean},
    name: {type: String},
    index: {type: Number, default: null},
    supportedFile: {
      type: String,
      default: 'image/*'
    },
    height: {type: Number, default: 200},
    compress: {type: Boolean},
    maxSize: {type: Number},
    maxWidthOrHeight: {type: Number},
    maxItems : {type : Number,default : null},
  },
  mounted()
  {
  },
  data()
  {
    return {
      dragging: false,
      results: null,
      fileId:'file-'+makeCode(12)
    };
  },
  methods: {
    handleFileInput(event)
    {
      this.processFileInput(event.target.files);
      // event.target.value = '';
    },
    handleDragOver(event)
    {
      event.stopPropagation();
      event.preventDefault();
      this.dragging = event.type === 'dragover';
      event.dataTransfer.dropEffect = 'copy';
    },
    handleFileSelect(event)
    {
      event.stopPropagation();
      event.preventDefault();
      this.dragging = false;
      this.processFileInput(event.dataTransfer.files);
    },
    async processFileInput(files)
    {
      const self = this;
      for (let i = 0; i < files.length; i++)
      {
        let file = files[i];
        if (file.type.match('image.*'))
        {
          let reader = new FileReader();
          reader.onloadend = async function ()
          {
            // if (this.results === null)
            //   this.results = [];

            if (self.compress)
            {
              const options = {
                maxSizeMB: self.maxSize?self.maxSize:0.35,
                maxWidthOrHeight: self.maxWidthOrHeight?self.maxWidthOrHeight:1920,
                useWebWorker: true
              }
              try
              {
                const compressedFile = await imageCompression(file, options);

                const fileType = file.type;
                file=new File([compressedFile], file.name, {type:fileType});


                // file.type = fileType;
              }
              catch (error)
              {
                console.log(error);
              }
            }

            const file_id = 'f_'+makeCode(9);

            const results = {
              filePreview: reader.result,
              file: file,file_id
            };

              if (!this.results)
                this.results = [];
              this.results.push(results);

              setTimeout(()=>{
                let container = new DataTransfer();
                container.items.add(file);
                document.querySelector('#'+results.file_id).files = container.files;
              },100)



            this.$emit('handleInput', results, this.index);
          }.bind(this);
          reader.readAsDataURL(file);
        }
      }
      document.querySelector('#'+self.fileId).files = null;
    },
    clearResults()
    {
      this.$refs.fileInput.value = null;
      this.results = null;
      this.$emit('handleInput', null, this.index);
      document.querySelector('#'+this.fileId).files = '';
    },
    clickInput()
    {
      this.$refs.fileInput.click();
    },
    deletePic(index)
    {
      this.results.splice(index,1);
    }
  }
};
</script>

<style scoped>
.main-div {
  position: relative;
  margin: 15px;
}

.uploader-header {
  display: flex;
  width: 100%;
  height: 40px;
  background-color: #E0E7EC;
  flex-direction: column;
  justify-content: center;
}

.drag-drop-upload {
  width: 100%;
  height: 100%;
  /*min-height: 200px;*/
  border: 1px dashed #94A2AB;
  cursor: pointer;
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  z-index: 0;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}

.drag-drop-upload.dragging {
  background-color: #e2e8f0;
  border-color: #667eea;
}

.drag-drop-upload .file-input {
  height: 100%;
  pointer-events: none;
  margin-bottom: 0;
  font-size: 1.5rem;
  color: #718096;
  text-align: center;

}

.image-preview {
  max-width: 100%;
  width: 100%;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  overflow: hidden;
  top: 0;
  z-index: 0;
  text-align: center;
}

input[type="file"] {
  display: none;
}

.drag-title {
  font-size: 13px;
}

.top-div {
  min-width: 150px;
}

.img-results
{
  padding: 5px;
}
.img-results .img-div {
  width: 80px;
  height: 80px;
  position: relative;
  box-shadow: -1px 1px 5px 1px #00000080;
  border-radius: 10px;
  overflow: hidden;
}
.img-results img
{
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
}
.img-results .remove-btn {
  position: absolute;
  text-shadow: -1px 1px 2px white;
  color: #cc1515;
  font-size: 23px;
  cursor: pointer;
}

</style>
